var React = require('react');

function RadioChecked (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)"},[React.createElement("ellipse",{"cx":"10","cy":"10.25","stroke":"#BF8AC0","strokeWidth":"2","rx":"10","ry":"10.25","key":0}),React.createElement("ellipse",{"cx":"10","cy":"10.25","fill":"#BF8AC0","fillOpacity":".5","rx":"6.25","ry":"6.406","key":1})]));
}

RadioChecked.defaultProps = {"width":"22","height":"23","viewBox":"0 0 22 23"};

module.exports = RadioChecked;

RadioChecked.default = RadioChecked;
